<template>
  <div class="shadow overflow-hidden rounded-lg" :class="{ 'h-full pb-10': inSession }">
    <div class="px-4 py-2 border-gray-200 border bg-gray-50 rounded-t-lg">
      <h3 class="text-lg leading-6 font-medium text-vice-teal-700 ml-2" v-if="$slots.header">
        <slot name="header"></slot>
      </h3>
    </div>
    <div
      class="bg-white border border-t-0 rounded-b-lg h-full"
      :class="{ 'h-full': inSession }"
      v-if="$slots.content"
    >
      <div class="px-4 py-5 sm:p-4 h-full">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReflectionCard',
  props: {
    inSession: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped></style>
